'use client';

import { useEffect } from 'react';
import { useAuth } from '@/lib/AuthContext';
import { useRouter, usePathname } from 'next/navigation';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    // Don't redirect if auth is still resolving
    if (loading) return;

    // Don't redirect if already on login/forgot-password/legal pages
    if (pathname === '/login' || pathname === '/forgot-password' || pathname === '/privacy' || pathname === '/terms') return;

    // Redirect to login if not authenticated
    if (!user) {
      console.log(' Not authenticated - redirecting to login');
      router.push('/login');
    }
  }, [user, loading, router, pathname]);

  // While auth is resolving, don't flash any blocking "authenticating" screen.
  // Let individual pages show their own loading states instead.
  if (loading) {
    return null;
  }

  // Show nothing if not authenticated (will redirect)
  if (!user && pathname !== '/login' && pathname !== '/forgot-password' && pathname !== '/privacy' && pathname !== '/terms') {
    return null;
  }

  // Render children if authenticated
  return <>{children}</>;
}

